export const iconFontAwesomeTextformattingTableCellsRowLock = (
	<i className="fa-solid fa-table-cells-row-lock"></i>
);
